import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL || "";

/**
 * Returns the canonical URL to share — uses REACT_APP_PUBLIC_URL if set,
 * otherwise falls back to current location. Includes current path + search.
 */
export function getShareUrl() {
  if (PUBLIC_URL) {
    const path = typeof window !== "undefined" ? window.location.pathname : "/";
    const search = typeof window !== "undefined" ? window.location.search : "";
    return `${PUBLIC_URL.replace(/\/$/, "")}${path === "/" ? "" : path}${search}`;
  }
  return typeof window !== "undefined" ? window.location.href : "";
}

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("scootive_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Coś poszło nie tak";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

// Lightweight browser fingerprint (no external lib)
export function computeFingerprint() {
  try {
    const cached = localStorage.getItem("scootive_fp");
    if (cached) return cached;
    const parts = [
      navigator.userAgent,
      navigator.language,
      navigator.platform || "",
      `${window.screen.width}x${window.screen.height}x${window.screen.colorDepth}`,
      Intl.DateTimeFormat().resolvedOptions().timeZone || "",
      String(new Date().getTimezoneOffset()),
      navigator.hardwareConcurrency || "",
      navigator.maxTouchPoints || 0,
    ];
    const seed = parts.join("|");
    // Simple FNV-1a hash
    let h = 0x811c9dc5;
    for (let i = 0; i < seed.length; i++) {
      h ^= seed.charCodeAt(i);
      h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
    }
    const fp = `fp_${h.toString(16)}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("scootive_fp", fp);
    return fp;
  } catch {
    return `fp_fallback_${Math.random().toString(36).slice(2, 10)}`;
  }
}
